export default __webpack_public_path__ + "7e640acf9871f159489ced27b178dc48.svg";